import { GCS_ENV_NAME } from "params"

export const DEFAULT_MAP_LOCATION = { lat: 0.33729009065358273, lng: 6.733702379794069 }

export const FLIGHT_NETWORK_NAME = GCS_ENV_NAME
export const DEPLOYMENT_NAME = GCS_ENV_NAME